import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, Observable, timer } from 'rxjs';
import { HttpService } from '@sdbn/appclient';
import { ResponseStatus } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SimulatorService {

  /** Hold the current status of the simulator. Will be refreshed periodically by backend calls. */
  private subject = new BehaviorSubject(false);


  constructor(private tmcHttpService: HttpService) {
    this.startPolling();
  }


  public toggle() {
    if (this.subject.getValue()) {
      this.tmcHttpService.get(`${environment.simulatorEndpoint}` + '/stop').toPromise().then((response: any) => {
        if (response.status === ResponseStatus.SUCCESS) {
          console.log('Simulator started');
        } else {
          console.log('Stoping simulator failed');
        }
      }, error => {
        console.log('Starting simulator failed with error:', error);
      });
    } else {
      this.tmcHttpService.get(`${environment.simulatorEndpoint}` + '/start').toPromise().then((response: any) => {
        if (response.status === ResponseStatus.SUCCESS) {
          console.log('Simulator stopped');
        } else {
          console.log('Stoping simulator failed');
        }
      }, error => {
        console.log('Stoping simulator failed with error:', error);
      });
    }
    this.subject.next(!this.subject.getValue());
  }

  public isSimulatorStarted(): boolean {
    return this.subject.getValue() === true;
  }

  public status(): BehaviorSubject<boolean> {
    return this.subject;
  }

  public stop() {
    this.subject.next(false);
  }

  private startPolling() {
    if (this.simulatorEnabled()) {
      timer(100, 30000).subscribe(() => {
        this.tmcHttpService.get(`${environment.simulatorEndpoint}` + '/status').toPromise().then((response: any) => {
          if (response.status === ResponseStatus.SUCCESS) {
            const simulatorStatus = response.simulatorStatus;
            this.subject.next(simulatorStatus === 'RUNNING');
          }
        }, error => {
          console.log('Status call for simulator failed with error:', error);
        });
      });
    } else {
      console.log('Simulator is not enabled. No status updates.');
    }
  }

  private simulatorEnabled() {
    return environment.simulatorAvailable;
  }

}
